import { render, staticRenderFns } from "./WorkcenterSelectorNavBlock.vue?vue&type=template&id=56ebdab9&scoped=true"
import script from "./WorkcenterSelectorNavBlock.vue?vue&type=script&lang=js"
export * from "./WorkcenterSelectorNavBlock.vue?vue&type=script&lang=js"
import style0 from "./WorkcenterSelectorNavBlock.vue?vue&type=style&index=0&id=56ebdab9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ebdab9",
  null
  
)

export default component.exports